export const cardStories = [
  {
    id: 202306,
    name: '梦想地',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '照片拍摄于法属波利尼西亚莫雷阿岛的一个沙洲，那里的鲨鱼游得十分靠近海滩，甚至在岛民的院子门前就可以看到。早晨的海水十分平静和清澈，大家可以在浅滩上花上几个小时观看这些优雅的生物而在这张照片上呈现的黑鳍礁鲨也是众多潜水员喜爱的鲨鱼之一，它们性情温和，通常生活在温暖的浅水水域。黑鳍礁鲨非常容易识别，它们的胸鳍和背鳍的顶端为明显的黑色，体侧有白色的条纹，容易辨识，常见于印度-太平洋海域。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2023/08/10/FuoYLVPn9YH241d3WUDFywAYw20i.jpg',
  },
  {
    id: 202401,
    name: '冬日掠食者',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '“让自然本身诉说美丽，通过摄影描绘海洋居民，展示我们星球上隐藏的宝藏。”这张照片是在挪威北部的一个叫Skjervay小渔村附近拍摄的。 每年冬天，大量的鲱鱼会从公海迁徙到挪威北部的峡湾，吸引大量的大型掠食者，如:逆戟鲸和座头鲸。 挪威冬季的白天较短，气候寒冷，冬天处于极夜的环境，水中活动和摄影充满挑战。所以每年只有几天有机会同时看到阳光入水和峡湾里的鲸鱼。 这张照片就是在这样的一天拍摄的。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2024/03/29/FigM5-c9DmmkHd3AaS3N6LQ_NjPX.jpg',
  },
  {
    id: 202402,
    name: '海底飞行',
    author: {
      name: '雷应涛',
      desc: ['PADI美人鱼教练训练官/首届中国美人鱼表演赛双料冠军', '2023中国美人鱼公开赛双料冠军'],
      sign: '',
      imgName: 'Leiyingtao',
    },
    story:
      '在马尔代夫船宿的夜晚，每条船的船尾都亮着大灯，无数的浮游生物趋光而来，就像在大海上盛大的自助餐晚宴。那天我们的船尾吸引了7只MANTA同时出现，它们时而像飞船一样在海底潜行，时而来到水面翻滚着肚皮享受饕餮盛宴。每一只MANTA后背的纹路都不尽相同，巨大的MANTA在水下煽动着翅膀，无比优雅的飞行。有趣的是这张照片里的一只MANTA的翅膀还缺了一个小角，或许它也有着自己的经历吧。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2024/03/29/FkSUeNZkhTHyIjSpvyZkLx8PGRmK.jpg',
  },
  {
    id: 202404,
    name: '静止的时间',
    author: {
      name: 'Tom St. George.',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '这张照片拍摄于墨西哥图卢姆（Tulum, Mexico）附近，记录了Cenote Angelita 的梦幻场景。照片中的潜水员是摄影师的妻子 Julia，他们将这个场景描述为：坍塌的碎石、树枝和落叶掉入洞穴组成的“小岛”，坐落在硫化氢的“云层”中。光线被水柱漫射，然后被“云层”反射，非常迷人。摄影师本人最喜欢这张照片的原因是它捕捉到了洞穴的精髓。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2024/10/18/FuRIcWJHwKuT_lY_0RtN05Gj-4No.jpg',
  },
  {
    id: 202403,
    name: '庇护所',
    author: {
      name: 'Martin Strmiska',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '这张照片拍摄于菲律宾卡比劳(Cabilao，Philippines)，摄影师在珊瑚礁进行晨潜时，偶然发现了这充满活力的组合:一对小丑鱼和它们的虾伙伴在海葵天鹅绒般的紫色触须中找到了庇护所。海葵最初是完全闭合的，两只小丑鱼拼命躲在几根触手之间，好奇地张望着探访者的到来。而眼前美丽色彩的呈现，促使摄影师逗留，静静等待海葵张开，并拍下了美丽的瞬间。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2024/10/18/Fn7B1AxRe0Q9jrSMDDu1g9xLqt98.jpg',
  },
  {
    id: 202501,
    name: '静谧之舟',
    author: {
      name: 'Alex Dawson',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '这张照片拍摄于埃及红海的 Shaabruhr Umm Qammar.东北端，沉船 Gulf Fleet 31 在海里的最大深度为104米，被夹在海下的一个坡道和珊瑚礁顶部之间，为混合气潜水员提供了可以在船体下方进行穿越游览的独特机会。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2025/01/10/Fj8VR8pEirblaJuGWsJqX5BoccIw.jpg',
  },
  {
    id: 202502,
    name: '海底之恋',
    author: {
      name: 'Gabriel Guzman',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '这张照片拍摄于大堡礁的 Moore Reef。这里的海龟交配季节是非常特殊的一段时期，因为海龟们表现出了一年中其他时间没有的独特行为，这让摄影师有机会拍摄到它们“为爱而战”的场景。这张照片的一切都非常理想：海洋环境丰富，能见度高，阳光明媚，还有海龟的活动场景。',
    imageUrl: 'https://img.yzcdn.cn/upload_files/2025/01/10/FmbEbcTDo7tMvduIBGAXwlbaFdrx.jpg',
  },
  {
    id: 202503,
    name: '海底星辰',
    author: {
      name: 'Daniel Nicholson',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story: '温柔的巨兽滑过宁格鲁礁——Daniel Nicholson 捕捉下与鲸鲨邂逅的震撼瞬间。',
    imageUrl: 'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E6%B5%B7%E5%BA%95%E6%98%9F%E8%BE%B0.jpg',
  },
  {
    id: 202603,
    name: '星纱共流年',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story:
      '海鲸鲨身披星辰，如深海中的温柔巨人；水母如纱，轻舞于它的身侧。星光与薄纱同游，神秘与敬畏并存。一次潜入，共度流年。',
    imageUrl:
      'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E6%98%9F%E7%BA%B1%E5%85%B1%E6%B5%81%E5%B9%B4.jpg',
  },
  {
    id: 202606,
    name: '深蓝初游',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story: '两只鲨鱼环绕成环，是深海极具对称美感的瞬间。如同每位潜水员初次奔赴深蓝，开启与海洋的约定。',
    imageUrl: 'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E6%B7%B1%E8%93%9D%E5%88%9D%E6%B8%B8.jpg',
  },
  {
    id: 202607,
    name: '海中绵羊',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story: '藻丛间藏着海洋软萌小精灵，斑斓纹路独具特色。潜入微距世界，邂逅深海里治愈的微小浪漫。',
    imageUrl: 'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E6%B5%B7%E4%B8%AD%E7%BB%B5%E7%BE%8A.jpg',
  },
  {
    id: 202608,
    name: '海洋的律动',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story: '万千蝠鲼成群巡游，在光束下随洋流舞动。这是大海生生不息的律动，见证海洋磅礴的生命力。',
    imageUrl:
      'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E6%B5%B7%E6%B4%8B%E7%9A%84%E5%BE%8B%E5%8A%A8.jpg',
  },
  {
    id: 202609,
    name: '碧波信使',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story: '海豚穿梭于水面之下，迎着碧波缓缓而来。它是蔚蓝的信使，奔赴每一场潜水者与深海的相逢。',
    imageUrl: 'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E7%A2%A7%E6%B3%A2%E4%BF%A1%E4%BD%BF.jpg',
  },
  {
    id: 202610,
    name: '双鲨逐澜',
    author: {
      name: '',
      desc: [],
      sign: '',
      imgName: 'default-author',
    },
    story: '大小鲸鲨身披星斑结伴遨游深海，相伴穿行幽蓝深渊。于浩瀚汪洋并肩逐浪，共赴蔚蓝征途。',
    imageUrl: 'https://ecards-img.oss-cn-shenzhen.aliyuncs.com/ECardImage/%E5%8F%8C%E9%B2%A8%E9%80%90%E6%BE%9C.jpg',
  },
]
